import React, {useEffect, useRef, useState} from 'react';
import FileViewer from "../../drive/fileViewer/fileViewer";
import UserInfo from "../userInfo/user-info";
import {formatDate, getGroupPhotoUrl, isSmallScreen} from "../../../utils/utils";
import {FormattedMessage, useIntl} from "react-intl";
import {useSelector} from "react-redux";
import users from "../../users";
import {ConfirmationModal, IconButton} from "../index";
import functions from "../../../utils/functionsFirebase";
import avatarDefault from "../../../images/avatardefault.png";
import ButtonMenu from "../../app/buttonMenu/buttonMenu";
import DOMPurify from 'dompurify';

function GroupPost({fromGroup = true, post, group, tagsContainer, tags, canDeletePost}) {

    const intl = useIntl();

    const [showingMore, setShowingMore] = useState(false);
    const darkMode = useSelector(users.selectors.isDarkMode)
    const [deletingPost, setDeletingPost] = useState(false);

    const buttonOpenConfirmDeletePost = useRef();

    useEffect(() => {
        if (!tags) {
            return;
        }
        post.tagList = post.tags.split(' ').map(x => tags.find(y => x === y.id)).filter(x => x);
    }, []);

    function getCutPosition(start) {
        return post.description.indexOf(" ", start);
    }

    function getShowMore() {
        return post.description.length > 150
    }

    function getTags() {
        if (!tags) {
            return []
        }
        const myTags = post.tags.split(' ').map(x => tags.find(y => x === y.id)).filter(x => x);
        myTags.sort((a, b) => a.tag.localeCompare(b.tag));
        myTags.sort((a, b) => a.totalFiles - b.totalFiles);
        return myTags;
    }

    async function handleDeletePost(res) {
        if (!res) {
            return;
        }
        buttonOpenConfirmDeletePost.current.click();
        setDeletingPost(true);
        const deletePost = functions.httpsCallable('deleteGroupPost');
        await deletePost({postId: post.id, groupId: group.id});
    }

    return (
        <div className={"card m-4 ms-0 me-0 " + (isSmallScreen() && ' ms-0 me-0')}>
            <div className={"card-body " + (isSmallScreen() && '  p-2')}>
                {!fromGroup &&
                    <div>
                        <ButtonMenu forceBig={true} verified={true} route={"/groups/group-details/" + group.id}
                                    classIcon={false} className="mb-3"
                                    text={
                                        <div className="d-flex flex-row align-items-center">
                                            <img style={{height: '3rem'}} className="image-border"
                                                 src={getGroupPhotoUrl(group) ?? avatarDefault}/>
                                            <div className="ms-2" style={{width: "100%"}}>
                                                {group.groupName}
                                            </div>
                                        </div>
                                    }/>
                    </div>}
                <div>
                    <div className="d-flex flex-row mb-2 align-items-center">
                        <div>
                            <UserInfo uid={post.file.uid} initialUser={post.user}
                                      setUserInParentObject={user => post.user = user}
                                      nameDecorations={group.uidCreator === post.file.uid && fromGroup &&
                                          <span style={{color: "gold"}}> <i
                                              title={intl.formatMessage({id: "groups.group-leader"})}
                                              className={"fa-solid fa-crown " + (isSmallScreen() ? 'ms-1' : 'ms-2')}></i></span>}/>
                        </div>
                    </div>

                </div>
                <div className="d-flex flex-row" style={{overflow: "auto"}}>
                    {getTags().map(tag => {
                        if (!tag) {
                            return;
                        }
                        return (
                            <span key={tag.id}
                                  className={"badge rounded-pill me-1 d-flex flex-row align-items-center " + (darkMode ? "text-light" : "text-dark")}
                                  style={{backgroundColor: darkMode ? "dimgray" : "whitesmoke"}}>
                             <div style={{
                                 width: "14px",
                                 height: "14px",
                                 borderRadius: "40px",
                                 backgroundColor: tag?.color
                             }}
                                  className=" me-1"></div>
                                {tag?.tag}
                        </span>)
                    })}
                    {!deletingPost ? tagsContainer : <IconButton icon="fa-solid fa-spinner fa-spin" className="ms-1"
                                                                 disabled={true}/>}
                </div>
                <h5 className="card-title mt-1">
                    {post.title}
                </h5>
                <FileViewer file={post.file} maxHeightItems={"30vh"} showInfo={false}/>
                <div className="mt-1">
                    {(getShowMore() && !showingMore) ? (
                        <span>
          <span
              dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(post.description.substring(0, getCutPosition(100)))}}/>
          <a onClick={() => setShowingMore(true)}
             className="text-primary"
             style={{cursor: "pointer"}}>
            [<FormattedMessage id="group-post.description.show-more"/>...]
          </a>
        </span>
                    ) : (
                        <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(post.description)}}/>
                    )}
                </div>
                <div className="d-flex flex-row justify-content-between">
                    <small style={{fontSize: "small"}}>
                        {(getShowMore() && showingMore) &&
                            <a onClick={() => setShowingMore(false)} className="text-primary"
                               style={{cursor: "pointer"}}>[<FormattedMessage
                                id="group-post.description.show-less"/>...]</a>}
                    </small>
                    <small style={{fontSize: "small"}} className="d-flex flex-row">
                        {formatDate(new Date(Number(post.dateTimestamp)))}
                        {canDeletePost && !deletingPost &&
                            <IconButton id="buttonDeletePost" icon="fa-solid fa-trash" className="text-danger ms-1"
                                        onClick={() => buttonOpenConfirmDeletePost.current.click()}/>}
                        {canDeletePost && deletingPost &&
                            <IconButton icon="fa-solid fa-spinner fa-spin" className="ms-1"
                                        disabled={true}/>}
                    </small>
                    <button hidden={true} data-bs-toggle="modal" data-bs-target={"#confirmDeletePost" + post.id}
                            ref={buttonOpenConfirmDeletePost}>
                    </button>
                </div>
            </div>
            <ConfirmationModal
                onClose={handleDeletePost}
                title={intl.formatMessage({id: "group-post.post-delete.warning.title"})}
                message={intl.formatMessage({id: "group-post.post-delete.warning.message"})}
                btnClass="btn-danger" modalName={"confirmDeletePost" + post.id}
                loading={deletingPost}/>
        </div>
    )

}

export default GroupPost;
